function requestAPI(productId) {
  return fetch(`${process.env.REACT_APP_BASE_URL}product/${productId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((res) => res.json())
}

export default function actionDetailProduct(productId) {
  return async (dispatch) => {
    dispatch({
      type: 'DETAIL_PRODUCT_BEGIN'
    })

    try {
      const result = await requestAPI(productId)
      if(!result.status) {
        handleErrors(dispatch, result)
        return
      }

      dispatch({
        type: 'DETAIL_PRODUCT_SUCCESS',
        payload: result.data
      })
    } catch (err) {
      handleErrors(dispatch, err)
    }
  }
}

function handleErrors(dispatch, error) {
  dispatch({        
    type: 'DETAIL_PRODUCT_FAILURE',        
    error: error    
  })
}